import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DaveEventListEntryModule } from '../../../../dave-event-list-entry/dave-event-list-entry.module';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../../../../dave-utils-module/app-filter-module/app-filter.module';
import { DetailCommissionEventListComponent } from './detail-commission-event-list.component';

@NgModule({
    declarations: [DetailCommissionEventListComponent],
    exports: [DetailCommissionEventListComponent, DetailCommissionEventListComponent],
    imports: [
        CommonModule,
        ScrollingModule,
        FontAwesomeModule,
        MatTabsModule,
        AppButtonModule,
        MatExpansionModule,
        MatTooltipModule,
        MatMenuModule,
        MatCardModule,
        DaveEventListEntryModule,
        MatProgressBarModule,
        AppFilterModule,
        MatBadgeModule,
        MatInputModule,
        MatButtonModule,
        ReactiveFormsModule,
    ],
})
export class DetailCommissionEventListModule {}
